/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_2Inputs */

const en_cap_promise_2 = /** @type {(inputs: Cap_Promise_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agreed limits`)
};

const lv_cap_promise_2 = /** @type {(inputs: Cap_Promise_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņotas robežas`)
};

/**
* | output |
* | --- |
* | "Agreed limits" |
*
* @param {Cap_Promise_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_2 = /** @type {((inputs?: Cap_Promise_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_2(inputs)
	return en_cap_promise_2(inputs)
});